/**
 * Site is the public, framework-agnostic model of a tenant website. It owns its
 * metadata and small presentation rules (e.g. which host to show visitors).
 */
export class Site {
    slug;
    name;
    customDomain;
    allowMultiUser;
    /** True when unpaid; SAMPLE wallpaper should show. */
    sample;
    /** True when Connect is ready for online card orders. */
    ordersEnabled;
    /** True when the kitchen printer Pi is offline during open hours (#886). */
    kitchenOffline;
    constructor(dto) {
        this.slug = dto.slug;
        this.name = dto.name;
        this.customDomain = dto.customDomain;
        this.allowMultiUser = dto.allowMultiUser;
        this.sample = dto.sample;
        this.ordersEnabled = dto.ordersEnabled === true;
        this.kitchenOffline = dto.kitchenOffline === true;
    }
    /** Checkout should warn or pause when ordering is enabled but the kitchen edge is down. */
    orderingPaused() {
        return this.kitchenOffline;
    }
    /** The host a visitor should use: the custom domain when set, else the slug. */
    primaryHost() {
        return this.customDomain || this.slug;
    }
    hasCustomDomain() {
        return this.customDomain.trim().length > 0;
    }
}
//# sourceMappingURL=Site.js.map